export default [
  {
    parent: 'US',
    key: 'US-AL',
    value: 'Alabama',
    localName: 'Alabama',
  },
  {
    parent: 'US',
    key: 'US-AK',
    value: 'Alaska',
    localName: 'Alaska',
  },
  {
    parent: 'US',
    key: 'US-AZ',
    value: 'Arizona',
    localName: 'Arizona',
  },
  {
    parent: 'US',
    key: 'US-AR',
    value: 'Arkansas',
    localName: 'Arkansas',
  },
  {
    parent: 'US',
    key: 'US-CA',
    value: 'California',
    localName: 'California',
  },
  {
    parent: 'US',
    key: 'US-CO',
    value: 'Colorado',
    localName: 'Colorado',
  },
  {
    parent: 'US',
    key: 'US-CT',
    value: 'Connecticut',
    localName: 'Connecticut',
  },
  {
    parent: 'US',
    key: 'US-DE',
    value: 'Delaware',
    localName: 'Delaware',
  },
  {
    parent: 'US',
    key: 'US-FL',
    value: 'Florida',
    localName: 'Florida',
  },
  {
    parent: 'US',
    key: 'US-GA',
    value: 'Georgia',
    localName: 'Georgia',
  },
  {
    parent: 'US',
    key: 'US-HI',
    value: 'Hawaii',
    localName: 'Hawaii',
  },
  {
    parent: 'US',
    key: 'US-ID',
    value: 'Idaho',
    localName: 'Idaho',
  },
  {
    parent: 'US',
    key: 'US-IL',
    value: 'Illinois',
    localName: 'Illinois',
  },
  {
    parent: 'US',
    key: 'US-IN',
    value: 'Indiana',
    localName: 'Indiana',
  },
  {
    parent: 'US',
    key: 'US-IA',
    value: 'Iowa',
    localName: 'Iowa',
  },
  {
    parent: 'US',
    key: 'US-KS',
    value: 'Kansas',
    localName: 'Kansas',
  },
  {
    parent: 'US',
    key: 'US-KY',
    value: 'Kentucky',
    localName: 'Kentucky',
  },
  {
    parent: 'US',
    key: 'US-LA',
    value: 'Louisiana',
    localName: 'Louisiana',
  },
  {
    parent: 'US',
    key: 'US-ME',
    value: 'Maine',
    localName: 'Maine',
  },
  {
    parent: 'US',
    key: 'US-MD',
    value: 'Maryland',
    localName: 'Maryland',
  },
  {
    parent: 'US',
    key: 'US-MA',
    value: 'Massachusetts',
    localName: 'Massachusetts',
  },
  {
    parent: 'US',
    key: 'US-MI',
    value: 'Michigan',
    localName: 'Michigan',
  },
  {
    parent: 'US',
    key: 'US-MN',
    value: 'Minnesota',
    localName: 'Minnesota',
  },
  {
    parent: 'US',
    key: 'US-MS',
    value: 'Mississippi',
    localName: 'Mississippi',
  },
  {
    parent: 'US',
    key: 'US-MO',
    value: 'Missouri',
    localName: 'Missouri',
  },
  {
    parent: 'US',
    key: 'US-MT',
    value: 'Montana',
    localName: 'Montana',
  },
  {
    parent: 'US',
    key: 'US-NE',
    value: 'Nebraska',
    localName: 'Nebraska',
  },
  {
    parent: 'US',
    key: 'US-NV',
    value: 'Nevada',
    localName: 'Nevada',
  },
  {
    parent: 'US',
    key: 'US-NH',
    value: 'New Hampshire',
    localName: 'New Hampshire',
  },
  {
    parent: 'US',
    key: 'US-NJ',
    value: 'New Jersey',
    localName: 'New Jersey',
  },
  {
    parent: 'US',
    key: 'US-NM',
    value: 'New Mexico',
    localName: 'New Mexico',
  },
  {
    parent: 'US',
    key: 'US-NY',
    value: 'New York',
    localName: 'New York',
  },
  {
    parent: 'US',
    key: 'US-NC',
    value: 'North Carolina',
    localName: 'North Carolina',
  },
  {
    parent: 'US',
    key: 'US-ND',
    value: 'North Dakota',
    localName: 'North Dakota',
  },
  {
    parent: 'US',
    key: 'US-OH',
    value: 'Ohio',
    localName: 'Ohio',
  },
  {
    parent: 'US',
    key: 'US-OK',
    value: 'Oklahoma',
    localName: 'Oklahoma',
  },
  {
    parent: 'US',
    key: 'US-OR',
    value: 'Oregon',
    localName: 'Oregon',
  },
  {
    parent: 'US',
    key: 'US-PA',
    value: 'Pennsylvania',
    localName: 'Pennsylvania',
  },
  {
    parent: 'US',
    key: 'US-RI',
    value: 'Rhode Island',
    localName: 'Rhode Island',
  },
  {
    parent: 'US',
    key: 'US-SC',
    value: 'South Carolina',
    localName: 'South Carolina',
  },
  {
    parent: 'US',
    key: 'US-SD',
    value: 'South Dakota',
    localName: 'South Dakota',
  },
  {
    parent: 'US',
    key: 'US-TN',
    value: 'Tennessee',
    localName: 'Tennessee',
  },
  {
    parent: 'US',
    key: 'US-TX',
    value: 'Texas',
    localName: 'Texas',
  },
  {
    parent: 'US',
    key: 'US-UT',
    value: 'Utah',
    localName: 'Utah',
  },
  {
    parent: 'US',
    key: 'US-VT',
    value: 'Vermont',
    localName: 'Vermont',
  },
  {
    parent: 'US',
    key: 'US-VA',
    value: 'Virginia',
    localName: 'Virginia',
  },
  {
    parent: 'US',
    key: 'US-WA',
    value: 'Washington',
    localName: 'Washington',
  },
  {
    parent: 'US',
    key: 'US-WV',
    value: 'West Virginia',
    localName: 'West Virginia',
  },
  {
    parent: 'US',
    key: 'US-WI',
    value: 'Wisconsin',
    localName: 'Wisconsin',
  },
  {
    parent: 'US',
    key: 'US-WY',
    value: 'Wyoming',
    localName: 'Wyoming',
  },
  {
    parent: 'CA',
    key: 'CA-AB',
    value: 'Alberta',
    localName: 'Alberta',
  },
  {
    parent: 'CA',
    key: 'CA-BC',
    value: 'British Columbia',
    localName: 'British Columbia',
  },
  {
    parent: 'CA',
    key: 'CA-MB',
    value: 'Manitoba',
    localName: 'Manitoba',
  },
  {
    parent: 'CA',
    key: 'CA-NB',
    value: 'New Brunswick',
    localName: 'New Brunswick',
  },
  {
    parent: 'CA',
    key: 'CA-NL',
    value: 'Newfoundland and Labrador',
    localName: 'Newfoundland and Labrador',
  },
  {
    parent: 'CA',
    key: 'CA-NS',
    value: 'Nova Scotia',
    localName: 'Nova Scotia',
  },
  {
    parent: 'CA',
    key: 'CA-ON',
    value: 'Ontario',
    localName: 'Ontario',
  },
  {
    parent: 'CA',
    key: 'CA-PE',
    value: 'Prince Edward Island',
    localName: 'Prince Edward Island',
  },
  {
    parent: 'CA',
    key: 'CA-QC',
    value: 'Quebec',
    localName: 'Quebec',
  },
  {
    parent: 'CA',
    key: 'CA-SK',
    value: 'Saskatchewan',
    localName: 'Saskatchewan',
  },
  {
    parent: 'CA',
    key: 'CA-NT',
    value: 'Northwest Territories',
    localName: 'Northwest Territories',
  },
  {
    parent: 'CA',
    key: 'CA-NU',
    value: 'Nunavut',
    localName: 'Nunavut',
  },
  {
    parent: 'CA',
    key: 'CA-YT',
    value: 'Yukon',
    localName: 'Yukon',
  },
  {
    parent: 'MX',
    key: 'MX-AGU',
    value: 'Aguascalientes',
    localName: 'Aguascalientes',
  },
  {
    parent: 'MX',
    key: 'MX-BCN',
    value: 'Baja California',
    localName: 'Baja California',
  },
  {
    parent: 'MX',
    key: 'MX-BCS',
    value: 'Baja California Sur',
    localName: 'Baja California Sur',
  },
  {
    parent: 'MX',
    key: 'MX-CAM',
    value: 'Campeche',
    localName: 'Campeche',
  },
  {
    parent: 'MX',
    key: 'MX-CHP',
    value: 'Chiapas',
    localName: 'Chiapas',
  },
  {
    parent: 'MX',
    key: 'MX-CHH',
    value: 'Chihuahua',
    localName: 'Chihuahua',
  },
  {
    parent: 'MX',
    key: 'MX-COA',
    value: 'Coahuila',
    localName: 'Coahuila',
  },
  {
    parent: 'MX',
    key: 'MX-COL',
    value: 'Colima',
    localName: 'Colima',
  },
  {
    parent: 'MX',
    key: 'MX-CDMX',
    value: 'Ciudad de México',
    localName: 'Ciudad de México',
  },
  {
    parent: 'MX',
    key: 'MX-DUR',
    value: 'Durango',
    localName: 'Durango',
  },
  {
    parent: 'MX',
    key: 'MX-GUA',
    value: 'Guanajuato',
    localName: 'Guanajuato',
  },
  {
    parent: 'MX',
    key: 'MX-GRO',
    value: 'Guerrero',
    localName: 'Guerrero',
  },
  {
    parent: 'MX',
    key: 'MX-HID',
    value: 'Hidalgo',
    localName: 'Hidalgo',
  },
  {
    parent: 'MX',
    key: 'MX-JAL',
    value: 'Jalisco',
    localName: 'Jalisco',
  },
  {
    parent: 'MX',
    key: 'MX-MEX',
    value: 'México',
    localName: 'México',
  },
  {
    parent: 'MX',
    key: 'MX-MIC',
    value: 'Michoacán',
    localName: 'Michoacán',
  },
  {
    parent: 'MX',
    key: 'MX-MOR',
    value: 'Morelos',
    localName: 'Morelos',
  },
  {
    parent: 'MX',
    key: 'MX-NAY',
    value: 'Nayarit',
    localName: 'Nayarit',
  },
  {
    parent: 'MX',
    key: 'MX-NLE',
    value: 'Nuevo León',
    localName: 'Nuevo León',
  },
  {
    parent: 'MX',
    key: 'MX-OAX',
    value: 'Oaxaca',
    localName: 'Oaxaca',
  },
  {
    parent: 'MX',
    key: 'MX-PUE',
    value: 'Puebla',
    localName: 'Puebla',
  },
  {
    parent: 'MX',
    key: 'MX-QUE',
    value: 'Querétaro',
    localName: 'Querétaro',
  },
  {
    parent: 'MX',
    key: 'MX-ROO',
    value: 'Quintana Roo',
    localName: 'Quintana Roo',
  },
  {
    parent: 'MX',
    key: 'MX-SLP',
    value: 'San Luis Potosí',
    localName: 'San Luis Potosí',
  },
  {
    parent: 'MX',
    key: 'MX-SIN',
    value: 'Sinaloa',
    localName: 'Sinaloa',
  },
  {
    parent: 'MX',
    key: 'MX-SON',
    value: 'Sonora',
    localName: 'Sonora',
  },
  {
    parent: 'MX',
    key: 'MX-TAB',
    value: 'Tabasco',
    localName: 'Tabasco',
  },
  {
    parent: 'MX',
    key: 'MX-TAM',
    value: 'Tamaulipas',
    localName: 'Tamaulipas',
  },
  {
    parent: 'MX',
    key: 'MX-TLA',
    value: 'Tlaxcala',
    localName: 'Tlaxcala',
  },
  {
    parent: 'MX',
    key: 'MX-VER',
    value: 'Veracruz',
    localName: 'Veracruz',
  },
  {
    parent: 'MX',
    key: 'MX-YUC',
    value: 'Yucatán',
    localName: 'Yucatán',
  },
  {
    parent: 'MX',
    key: 'MX-ZAC',
    value: 'Zacatecas',
    localName: 'Zacatecas',
  },
  {
    parent: 'BR',
    key: 'BR-AC',
    value: 'Acre',
    localName: 'Acre',
  },
  {
    parent: 'BR',
    key: 'BR-AL',
    value: 'Alagoas',
    localName: 'Alagoas',
  },
  {
    parent: 'BR',
    key: 'BR-AP',
    value: 'Amapá',
    localName: 'Amapá',
  },
  {
    parent: 'BR',
    key: 'BR-AM',
    value: 'Amazonas',
    localName: 'Amazonas',
  },
  {
    parent: 'BR',
    key: 'BR-BA',
    value: 'Bahia',
    localName: 'Bahia',
  },
  {
    parent: 'BR',
    key: 'BR-CE',
    value: 'Ceará',
    localName: 'Ceará',
  },
  {
    parent: 'BR',
    key: 'BR-DF',
    value: 'Distrito Federal',
    localName: 'Distrito Federal',
  },
  {
    parent: 'BR',
    key: 'BR-ES',
    value: 'Espírito Santo',
    localName: 'Espírito Santo',
  },
  {
    parent: 'BR',
    key: 'BR-GO',
    value: 'Goiás',
    localName: 'Goiás',
  },
  {
    parent: 'BR',
    key: 'BR-MA',
    value: 'Maranhão',
    localName: 'Maranhão',
  },
  {
    parent: 'BR',
    key: 'BR-MT',
    value: 'Mato Grosso',
    localName: 'Mato Grosso',
  },
  {
    parent: 'BR',
    key: 'BR-MS',
    value: 'Mato Grosso do Sul',
    localName: 'Mato Grosso do Sul',
  },
  {
    parent: 'BR',
    key: 'BR-MG',
    value: 'Minas Gerais',
    localName: 'Minas Gerais',
  },
  {
    parent: 'BR',
    key: 'BR-PA',
    value: 'Pará',
    localName: 'Pará',
  },
  {
    parent: 'BR',
    key: 'BR-PB',
    value: 'Paraíba',
    localName: 'Paraíba',
  },
  {
    parent: 'BR',
    key: 'BR-PR',
    value: 'Paraná',
    localName: 'Paraná',
  },
  {
    parent: 'BR',
    key: 'BR-PE',
    value: 'Pernambuco',
    localName: 'Pernambuco',
  },
  {
    parent: 'BR',
    key: 'BR-PI',
    value: 'Piauí',
    localName: 'Piauí',
  },
  {
    parent: 'BR',
    key: 'BR-RJ',
    value: 'Rio de Janeiro',
    localName: 'Rio de Janeiro',
  },
  {
    parent: 'BR',
    key: 'BR-RN',
    value: 'Rio Grande do Norte',
    localName: 'Rio Grande do Norte',
  },
  {
    parent: 'BR',
    key: 'BR-RS',
    value: 'Rio Grande do Sul',
    localName: 'Rio Grande do Sul',
  },
  {
    parent: 'BR',
    key: 'BR-RO',
    value: 'Rondônia',
    localName: 'Rondônia',
  },
  {
    parent: 'BR',
    key: 'BR-RR',
    value: 'Roraima',
    localName: 'Roraima',
  },
  {
    parent: 'BR',
    key: 'BR-SC',
    value: 'Santa Catarina',
    localName: 'Santa Catarina',
  },
  {
    parent: 'BR',
    key: 'BR-SP',
    value: 'São Paulo',
    localName: 'São Paulo',
  },
  {
    parent: 'BR',
    key: 'BR-SE',
    value: 'Sergipe',
    localName: 'Sergipe',
  },
  {
    parent: 'BR',
    key: 'BR-TO',
    value: 'Tocantins',
    localName: 'Tocantins',
  },
  {
    parent: 'AR',
    key: 'AR-C',
    value: 'Ciudad Autónoma de Buenos Aires',
    localName: 'Ciudad Autónoma de Buenos Aires',
  },
  {
    parent: 'AR',
    key: 'AR-B',
    value: 'Buenos Aires',
    localName: 'Buenos Aires',
  },
  {
    parent: 'AR',
    key: 'AR-K',
    value: 'Catamarca',
    localName: 'Catamarca',
  },
  {
    parent: 'AR',
    key: 'AR-H',
    value: 'Chaco',
    localName: 'Chaco',
  },
  {
    parent: 'AR',
    key: 'AR-U',
    value: 'Chubut',
    localName: 'Chubut',
  },
  {
    parent: 'AR',
    key: 'AR-X',
    value: 'Córdoba',
    localName: 'Córdoba',
  },
  {
    parent: 'AR',
    key: 'AR-W',
    value: 'Corrientes',
    localName: 'Corrientes',
  },
  {
    parent: 'AR',
    key: 'AR-E',
    value: 'Entre Ríos',
    localName: 'Entre Ríos',
  },
  {
    parent: 'AR',
    key: 'AR-P',
    value: 'Formosa',
    localName: 'Formosa',
  },
  {
    parent: 'AR',
    key: 'AR-Y',
    value: 'Jujuy',
    localName: 'Jujuy',
  },
  {
    parent: 'AR',
    key: 'AR-L',
    value: 'La Pampa',
    localName: 'La Pampa',
  },
  {
    parent: 'AR',
    key: 'AR-F',
    value: 'La Rioja',
    localName: 'La Rioja',
  },
  {
    parent: 'AR',
    key: 'AR-M',
    value: 'Mendoza',
    localName: 'Mendoza',
  },
  {
    parent: 'AR',
    key: 'AR-N',
    value: 'Misiones',
    localName: 'Misiones',
  },
  {
    parent: 'AR',
    key: 'AR-Q',
    value: 'Neuquén',
    localName: 'Neuquén',
  },
  {
    parent: 'AR',
    key: 'AR-R',
    value: 'Río Negro',
    localName: 'Río Negro',
  },
  {
    parent: 'AR',
    key: 'AR-A',
    value: 'Salta',
    localName: 'Salta',
  },
  {
    parent: 'AR',
    key: 'AR-J',
    value: 'San Juan',
    localName: 'San Juan',
  },
  {
    parent: 'AR',
    key: 'AR-D',
    value: 'San Luis',
    localName: 'San Luis',
  },
  {
    parent: 'AR',
    key: 'AR-Z',
    value: 'Santa Cruz',
    localName: 'Santa Cruz',
  },
  {
    parent: 'AR',
    key: 'AR-S',
    value: 'Santa Fe',
    localName: 'Santa Fe',
  },
  {
    parent: 'AR',
    key: 'AR-G',
    value: 'Santiago del Estero',
    localName: 'Santiago del Estero',
  },
  {
    parent: 'AR',
    key: 'AR-V',
    value: 'Tierra del Fuego',
    localName: 'Tierra del Fuego',
  },
  {
    parent: 'AR',
    key: 'AR-T',
    value: 'Tucumán',
    localName: 'Tucumán',
  },
  {
    parent: 'CO',
    key: 'CO-AMA',
    value: 'Amazonas',
    localName: 'Amazonas',
  },
  {
    parent: 'CO',
    key: 'CO-ANT',
    value: 'Antioquia',
    localName: 'Antioquia',
  },
  {
    parent: 'CO',
    key: 'CO-ARA',
    value: 'Arauca',
    localName: 'Arauca',
  },
  {
    parent: 'CO',
    key: 'CO-ATL',
    value: 'Atlántico',
    localName: 'Atlántico',
  },
  {
    parent: 'CO',
    key: 'CO-BOL',
    value: 'Bolívar',
    localName: 'Bolívar',
  },
  {
    parent: 'CO',
    key: 'CO-BOY',
    value: 'Boyacá',
    localName: 'Boyacá',
  },
  {
    parent: 'CO',
    key: 'CO-CAL',
    value: 'Caldas',
    localName: 'Caldas',
  },
  {
    parent: 'CO',
    key: 'CO-CAQ',
    value: 'Caquetá',
    localName: 'Caquetá',
  },
  {
    parent: 'CO',
    key: 'CO-CAS',
    value: 'Casanare',
    localName: 'Casanare',
  },
  {
    parent: 'CO',
    key: 'CO-CAU',
    value: 'Cauca',
    localName: 'Cauca',
  },
  {
    parent: 'CO',
    key: 'CO-CES',
    value: 'Cesar',
    localName: 'Cesar',
  },
  {
    parent: 'CO',
    key: 'CO-CHO',
    value: 'Chocó',
    localName: 'Chocó',
  },
  {
    parent: 'CO',
    key: 'CO-COR',
    value: 'Córdoba',
    localName: 'Córdoba',
  },
  {
    parent: 'CO',
    key: 'CO-CUN',
    value: 'Cundinamarca',
    localName: 'Cundinamarca',
  },
  {
    parent: 'CO',
    key: 'CO-DC',
    value: 'Distrito Capital de Bogotá',
    localName: 'Distrito Capital de Bogotá',
  },
  {
    parent: 'CO',
    key: 'CO-GUA',
    value: 'Guainía',
    localName: 'Guainía',
  },
  {
    parent: 'CO',
    key: 'CO-GUV',
    value: 'Guaviare',
    localName: 'Guaviare',
  },
  {
    parent: 'CO',
    key: 'CO-HUI',
    value: 'Huila',
    localName: 'Huila',
  },
  {
    parent: 'CO',
    key: 'CO-LAG',
    value: 'La Guajira',
    localName: 'La Guajira',
  },
  {
    parent: 'CO',
    key: 'CO-MAG',
    value: 'Magdalena',
    localName: 'Magdalena',
  },
  {
    parent: 'CO',
    key: 'CO-MET',
    value: 'Meta',
    localName: 'Meta',
  },
  {
    parent: 'CO',
    key: 'CO-NAR',
    value: 'Nariño',
    localName: 'Nariño',
  },
  {
    parent: 'CO',
    key: 'CO-NSA',
    value: 'Norte de Santander',
    localName: 'Norte de Santander',
  },
  {
    parent: 'CO',
    key: 'CO-PUT',
    value: 'Putumayo',
    localName: 'Putumayo',
  },
  {
    parent: 'CO',
    key: 'CO-QUI',
    value: 'Quindío',
    localName: 'Quindío',
  },
  {
    parent: 'CO',
    key: 'CO-RIS',
    value: 'Risaralda',
    localName: 'Risaralda',
  },
  {
    parent: 'CO',
    key: 'CO-SAN',
    value: 'Santander',
    localName: 'Santander',
  },
  {
    parent: 'CO',
    key: 'CO-SAP',
    value: 'San Andrés, Providencia y Santa Catalina',
    localName: 'San Andrés, Providencia y Santa Catalina',
  },
  {
    parent: 'CO',
    key: 'CO-SUC',
    value: 'Sucre',
    localName: 'Sucre',
  },
  {
    parent: 'CO',
    key: 'CO-TOL',
    value: 'Tolima',
    localName: 'Tolima',
  },
  {
    parent: 'CO',
    key: 'CO-VAC',
    value: 'Valle del Cauca',
    localName: 'Valle del Cauca',
  },
  {
    parent: 'CO',
    key: 'CO-VAU',
    value: 'Vaupés',
    localName: 'Vaupés',
  },
  {
    parent: 'CO',
    key: 'CO-VID',
    value: 'Vichada',
    localName: 'Vichada',
  },
  {
    parent: 'VE',
    key: 'VE-A',
    value: 'Distrito Capital',
    localName: 'Distrito Capital',
  },
  {
    parent: 'VE',
    key: 'VE-B',
    value: 'Anzoátegui',
    localName: 'Anzoátegui',
  },
  {
    parent: 'VE',
    key: 'VE-C',
    value: 'Apure',
    localName: 'Apure',
  },
  {
    parent: 'VE',
    key: 'VE-D',
    value: 'Aragua',
    localName: 'Aragua',
  },
  {
    parent: 'VE',
    key: 'VE-E',
    value: 'Barinas',
    localName: 'Barinas',
  },
  {
    parent: 'VE',
    key: 'VE-F',
    value: 'Bolívar',
    localName: 'Bolívar',
  },
  {
    parent: 'VE',
    key: 'VE-G',
    value: 'Carabobo',
    localName: 'Carabobo',
  },
  {
    parent: 'VE',
    key: 'VE-H',
    value: 'Cojedes',
    localName: 'Cojedes',
  },
  {
    parent: 'VE',
    key: 'VE-I',
    value: 'Falcón',
    localName: 'Falcón',
  },
  {
    parent: 'VE',
    key: 'VE-J',
    value: 'Guárico',
    localName: 'Guárico',
  },
  {
    parent: 'VE',
    key: 'VE-K',
    value: 'Lara',
    localName: 'Lara',
  },
  {
    parent: 'VE',
    key: 'VE-L',
    value: 'Mérida',
    localName: 'Mérida',
  },
  {
    parent: 'VE',
    key: 'VE-M',
    value: 'Miranda',
    localName: 'Miranda',
  },
  {
    parent: 'VE',
    key: 'VE-N',
    value: 'Monagas',
    localName: 'Monagas',
  },
  {
    parent: 'VE',
    key: 'VE-O',
    value: 'Nueva Esparta',
    localName: 'Nueva Esparta',
  },
  {
    parent: 'VE',
    key: 'VE-P',
    value: 'Portuguesa',
    localName: 'Portuguesa',
  },
  {
    parent: 'VE',
    key: 'VE-R',
    value: 'Sucre',
    localName: 'Sucre',
  },
  {
    parent: 'VE',
    key: 'VE-S',
    value: 'Táchira',
    localName: 'Táchira',
  },
  {
    parent: 'VE',
    key: 'VE-T',
    value: 'Trujillo',
    localName: 'Trujillo',
  },
  {
    parent: 'VE',
    key: 'VE-U',
    value: 'Yaracuy',
    localName: 'Yaracuy',
  },
  {
    parent: 'VE',
    key: 'VE-V',
    value: 'Zulia',
    localName: 'Zulia',
  },
  {
    parent: 'VE',
    key: 'VE-W',
    value: 'Amazonas',
    localName: 'Amazonas',
  },
  {
    parent: 'VE',
    key: 'VE-X',
    value: 'Delta Amacuro',
    localName: 'Delta Amacuro',
  },
  {
    parent: 'VE',
    key: 'VE-Y',
    value: 'Dependencias Federales',
    localName: 'Dependencias Federales',
  },
  {
    parent: 'IT',
    key: 'IT-21',
    value: 'Piemonte',
    localName: 'Piemonte',
  },
  {
    parent: 'IT',
    key: 'IT-23',
    value: "Valle d'Aosta",
    localName: "Valle d'Aosta",
  },
  {
    parent: 'IT',
    key: 'IT-25',
    value: 'Lombardia',
    localName: 'Lombardia',
  },
  {
    parent: 'IT',
    key: 'IT-32',
    value: 'Trentino-Alto Adige',
    localName: 'Trentino-Alto Adige',
  },
  {
    parent: 'IT',
    key: 'IT-34',
    value: 'Veneto',
    localName: 'Veneto',
  },
  {
    parent: 'IT',
    key: 'IT-36',
    value: 'Friuli Venezia Giulia',
    localName: 'Friuli Venezia Giulia',
  },
  {
    parent: 'IT',
    key: 'IT-42',
    value: 'Liguria',
    localName: 'Liguria',
  },
  {
    parent: 'IT',
    key: 'IT-45',
    value: 'Emilia-Romagna',
    localName: 'Emilia-Romagna',
  },
  {
    parent: 'IT',
    key: 'IT-52',
    value: 'Toscana',
    localName: 'Toscana',
  },
  {
    parent: 'IT',
    key: 'IT-55',
    value: 'Umbria',
    localName: 'Umbria',
  },
  {
    parent: 'IT',
    key: 'IT-57',
    value: 'Marche',
    localName: 'Marche',
  },
  {
    parent: 'IT',
    key: 'IT-62',
    value: 'Lazio',
    localName: 'Lazio',
  },
  {
    parent: 'IT',
    key: 'IT-65',
    value: 'Abruzzo',
    localName: 'Abruzzo',
  },
  {
    parent: 'IT',
    key: 'IT-67',
    value: 'Molise',
    localName: 'Molise',
  },
  {
    parent: 'IT',
    key: 'IT-72',
    value: 'Campania',
    localName: 'Campania',
  },
  {
    parent: 'IT',
    key: 'IT-75',
    value: 'Puglia',
    localName: 'Puglia',
  },
  {
    parent: 'IT',
    key: 'IT-77',
    value: 'Basilicata',
    localName: 'Basilicata',
  },
  {
    parent: 'IT',
    key: 'IT-78',
    value: 'Calabria',
    localName: 'Calabria',
  },
  {
    parent: 'IT',
    key: 'IT-82',
    value: 'Sicilia',
    localName: 'Sicilia',
  },
  {
    parent: 'IT',
    key: 'IT-88',
    value: 'Sardegna',
    localName: 'Sardegna',
  },
  {
    parent: 'ES',
    key: 'ES-AN',
    value: 'Andalucía',
    localName: 'Andalucía',
  },
  {
    parent: 'ES',
    key: 'ES-AR',
    value: 'Aragón',
    localName: 'Aragón',
  },
  {
    parent: 'ES',
    key: 'ES-AS',
    value: 'Asturias',
    localName: 'Asturias',
  },
  {
    parent: 'ES',
    key: 'ES-CN',
    value: 'Canarias',
    localName: 'Canarias',
  },
  {
    parent: 'ES',
    key: 'ES-CB',
    value: 'Cantabria',
    localName: 'Cantabria',
  },
  {
    parent: 'ES',
    key: 'ES-CM',
    value: 'Castilla-La Mancha',
    localName: 'Castilla-La Mancha',
  },
  {
    parent: 'ES',
    key: 'ES-CL',
    value: 'Castilla y León',
    localName: 'Castilla y León',
  },
  {
    parent: 'ES',
    key: 'ES-CT',
    value: 'Cataluña',
    localName: 'Cataluña',
  },
  {
    parent: 'ES',
    key: 'ES-EX',
    value: 'Extremadura',
    localName: 'Extremadura',
  },
  {
    parent: 'ES',
    key: 'ES-GA',
    value: 'Galicia',
    localName: 'Galicia',
  },
  {
    parent: 'ES',
    key: 'ES-IB',
    value: 'Islas Baleares',
    localName: 'Islas Baleares',
  },
  {
    parent: 'ES',
    key: 'ES-RI',
    value: 'La Rioja',
    localName: 'La Rioja',
  },
  {
    parent: 'ES',
    key: 'ES-MD',
    value: 'Madrid',
    localName: 'Madrid',
  },
  {
    parent: 'ES',
    key: 'ES-MC',
    value: 'Murcia',
    localName: 'Murcia',
  },
  {
    parent: 'ES',
    key: 'ES-NC',
    value: 'Navarra',
    localName: 'Navarra',
  },
  {
    parent: 'ES',
    key: 'ES-PV',
    value: 'País Vasco',
    localName: 'País Vasco',
  },
  {
    parent: 'ES',
    key: 'ES-VC',
    value: 'Comunidad Valenciana',
    localName: 'Comunidad Valenciana',
  },
  {
    parent: 'ES',
    key: 'ES-CE',
    value: 'Ceuta',
    localName: 'Ceuta',
  },
  {
    parent: 'ES',
    key: 'ES-ML',
    value: 'Melilla',
    localName: 'Melilla',
  },
  {
    parent: 'ZA',
    key: 'ZA-EC',
    value: 'Eastern Cape',
    localName: 'Eastern Cape',
  },
  {
    parent: 'ZA',
    key: 'ZA-FS',
    value: 'Free State',
    localName: 'Free State',
  },
  {
    parent: 'ZA',
    key: 'ZA-GP',
    value: 'Gauteng',
    localName: 'Gauteng',
  },
  {
    parent: 'ZA',
    key: 'ZA-KZN',
    value: 'KwaZulu-Natal',
    localName: 'KwaZulu-Natal',
  },
  {
    parent: 'ZA',
    key: 'ZA-LP',
    value: 'Limpopo',
    localName: 'Limpopo',
  },
  {
    parent: 'ZA',
    key: 'ZA-MP',
    value: 'Mpumalanga',
    localName: 'Mpumalanga',
  },
  {
    parent: 'ZA',
    key: 'ZA-NC',
    value: 'Northern Cape',
    localName: 'Northern Cape',
  },
  {
    parent: 'ZA',
    key: 'ZA-NW',
    value: 'North West',
    localName: 'North West',
  },
  {
    parent: 'ZA',
    key: 'ZA-WC',
    value: 'Western Cape',
    localName: 'Western Cape',
  },
  {
    parent: 'RU',
    key: 'RU-AD',
    value: 'Republic of Adygea',
    localName: 'Республика Адыгея',
  },
  {
    parent: 'RU',
    key: 'RU-AL',
    value: 'Altai Republic',
    localName: 'Республика Алтай',
  },
  {
    parent: 'RU',
    key: 'RU-BA',
    value: 'Republic of Bashkortostan',
    localName: 'Республика Башкортостан',
  },
  {
    parent: 'RU',
    key: 'RU-BU',
    value: 'Republic of Buryatia',
    localName: 'Республика Бурятия',
  },
  {
    parent: 'RU',
    key: 'RU-CE',
    value: 'Chechen Republic',
    localName: 'Чеченская Республика',
  },
  {
    parent: 'RU',
    key: 'RU-CU',
    value: 'Chuvash Republic',
    localName: 'Чувашская Республика',
  },
  {
    parent: 'RU',
    key: 'RU-DA',
    value: 'Republic of Dagestan',
    localName: 'Республика Дагестан',
  },
  {
    parent: 'RU',
    key: 'RU-IN',
    value: 'Republic of Ingushetia',
    localName: 'Республика Ингушетия',
  },
  {
    parent: 'RU',
    key: 'RU-KB',
    value: 'Kabardino-Balkarian Republic',
    localName: 'Кабардино-Балкарская Республика',
  },
  {
    parent: 'RU',
    key: 'RU-KL',
    value: 'Republic of Kalmykia',
    localName: 'Республика Калмыкия',
  },
  {
    parent: 'RU',
    key: 'RU-KC',
    value: 'Karachay-Cherkess Republic',
    localName: 'Карачаево-Черкесская Республика',
  },
  {
    parent: 'RU',
    key: 'RU-KR',
    value: 'Republic of Karelia',
    localName: 'Республика Карелия',
  },
  {
    parent: 'RU',
    key: 'RU-KK',
    value: 'Republic of Khakassia',
    localName: 'Республика Хакасия',
  },
  {
    parent: 'RU',
    key: 'RU-KO',
    value: 'Komi Republic',
    localName: 'Республика Коми',
  },
  {
    parent: 'RU',
    key: 'RU-ME',
    value: 'Mari El Republic',
    localName: 'Республика Марий Эл',
  },
  {
    parent: 'RU',
    key: 'RU-MO',
    value: 'Republic of Mordovia',
    localName: 'Республика Мордовия',
  },
  {
    parent: 'RU',
    key: 'RU-SA',
    value: 'Republic of Sakha (Yakutia)',
    localName: 'Республика Саха (Якутия)',
  },
  {
    parent: 'RU',
    key: 'RU-SE',
    value: 'Republic of North Ossetia-Alania',
    localName: 'Республика Северная Осетия — Алания',
  },
  {
    parent: 'RU',
    key: 'RU-TA',
    value: 'Republic of Tatarstan',
    localName: 'Республика Татарстан',
  },
  {
    parent: 'RU',
    key: 'RU-TY',
    value: 'Republic of Tuva',
    localName: 'Республика Тыва',
  },
  {
    parent: 'RU',
    key: 'RU-UD',
    value: 'Udmurt Republic',
    localName: 'Удмуртская Республика',
  },
  {
    parent: 'RU',
    key: 'RU-ALT',
    value: 'Altai Krai',
    localName: 'Алтайский край',
  },
  {
    parent: 'RU',
    key: 'RU-KAM',
    value: 'Kamchatka Krai',
    localName: 'Камчатский край',
  },
  {
    parent: 'RU',
    key: 'RU-KDA',
    value: 'Krasnodar Krai',
    localName: 'Краснодарский край',
  },
  {
    parent: 'RU',
    key: 'RU-KHA',
    value: 'Khabarovsk Krai',
    localName: 'Хабаровский край',
  },
  {
    parent: 'RU',
    key: 'RU-KYA',
    value: 'Krasnoyarsk Krai',
    localName: 'Красноярский край',
  },
  {
    parent: 'RU',
    key: 'RU-PER',
    value: 'Perm Krai',
    localName: 'Пермский край',
  },
  {
    parent: 'RU',
    key: 'RU-PRI',
    value: 'Primorsky Krai',
    localName: 'Приморский край',
  },
  {
    parent: 'RU',
    key: 'RU-STA',
    value: 'Stavropol Krai',
    localName: 'Ставропольский край',
  },
  {
    parent: 'RU',
    key: 'RU-ZAB',
    value: 'Zabaykalsky Krai',
    localName: 'Забайкальский край',
  },
  {
    parent: 'RU',
    key: 'RU-AMU',
    value: 'Amur Oblast',
    localName: 'Амурская область',
  },
  {
    parent: 'RU',
    key: 'RU-ARK',
    value: 'Arkhangelsk Oblast',
    localName: 'Архангельская область',
  },
  {
    parent: 'RU',
    key: 'RU-AST',
    value: 'Astrakhan Oblast',
    localName: 'Астраханская область',
  },
  {
    parent: 'RU',
    key: 'RU-BEL',
    value: 'Belgorod Oblast',
    localName: 'Белгородская область',
  },
  {
    parent: 'RU',
    key: 'RU-BRY',
    value: 'Bryansk Oblast',
    localName: 'Брянская область',
  },
  {
    parent: 'RU',
    key: 'RU-CHE',
    value: 'Chelyabinsk Oblast',
    localName: 'Челябинская область',
  },
  {
    parent: 'RU',
    key: 'RU-IRK',
    value: 'Irkutsk Oblast',
    localName: 'Иркутская область',
  },
  {
    parent: 'RU',
    key: 'RU-IVA',
    value: 'Ivanovo Oblast',
    localName: 'Ивановская область',
  },
  {
    parent: 'RU',
    key: 'RU-KGD',
    value: 'Kaliningrad Oblast',
    localName: 'Калининградская область',
  },
  {
    parent: 'RU',
    key: 'RU-KLU',
    value: 'Kaluga Oblast',
    localName: 'Калужская область',
  },
  {
    parent: 'RU',
    key: 'RU-KEM',
    value: 'Kemerovo Oblast',
    localName: 'Кемеровская область',
  },
  {
    parent: 'RU',
    key: 'RU-KIR',
    value: 'Kirov Oblast',
    localName: 'Кировская область',
  },
  {
    parent: 'RU',
    key: 'RU-KOS',
    value: 'Kostroma Oblast',
    localName: 'Костромская область',
  },
  {
    parent: 'RU',
    key: 'RU-KGN',
    value: 'Kurgan Oblast',
    localName: 'Курганская область',
  },
  {
    parent: 'RU',
    key: 'RU-KRS',
    value: 'Kursk Oblast',
    localName: 'Курская область',
  },
  {
    parent: 'RU',
    key: 'RU-LEN',
    value: 'Leningrad Oblast',
    localName: 'Ленинградская область',
  },
  {
    parent: 'RU',
    key: 'RU-LIP',
    value: 'Lipetsk Oblast',
    localName: 'Липецкая область',
  },
  {
    parent: 'RU',
    key: 'RU-MAG',
    value: 'Magadan Oblast',
    localName: 'Магаданская область',
  },
  {
    parent: 'RU',
    key: 'RU-MOS',
    value: 'Moscow Oblast',
    localName: 'Московская область',
  },
  {
    parent: 'RU',
    key: 'RU-MUR',
    value: 'Murmansk Oblast',
    localName: 'Мурманская область',
  },
  {
    parent: 'RU',
    key: 'RU-NIZ',
    value: 'Nizhny Novgorod Oblast',
    localName: 'Нижегородская область',
  },
  {
    parent: 'RU',
    key: 'RU-NGR',
    value: 'Novgorod Oblast',
    localName: 'Новгородская область',
  },
  {
    parent: 'RU',
    key: 'RU-NVS',
    value: 'Novosibirsk Oblast',
    localName: 'Новосибирская область',
  },
  {
    parent: 'RU',
    key: 'RU-OMS',
    value: 'Omsk Oblast',
    localName: 'Омская область',
  },
  {
    parent: 'RU',
    key: 'RU-ORE',
    value: 'Orenburg Oblast',
    localName: 'Оренбургская область',
  },
  {
    parent: 'RU',
    key: 'RU-ORL',
    value: 'Oryol Oblast',
    localName: 'Орловская область',
  },
  {
    parent: 'RU',
    key: 'RU-PNZ',
    value: 'Penza Oblast',
    localName: 'Пензенская область',
  },
  {
    parent: 'RU',
    key: 'RU-PSK',
    value: 'Pskov Oblast',
    localName: 'Псковская область',
  },
  {
    parent: 'RU',
    key: 'RU-ROS',
    value: 'Rostov Oblast',
    localName: 'Ростовская область',
  },
  {
    parent: 'RU',
    key: 'RU-RYA',
    value: 'Ryazan Oblast',
    localName: 'Рязанская область',
  },
  {
    parent: 'RU',
    key: 'RU-SAK',
    value: 'Sakhalin Oblast',
    localName: 'Сахалинская область',
  },
  {
    parent: 'RU',
    key: 'RU-SAM',
    value: 'Samara Oblast',
    localName: 'Самарская область',
  },
  {
    parent: 'RU',
    key: 'RU-SAR',
    value: 'Saratov Oblast',
    localName: 'Саратовская область',
  },
  {
    parent: 'RU',
    key: 'RU-SMO',
    value: 'Smolensk Oblast',
    localName: 'Смоленская область',
  },
  {
    parent: 'RU',
    key: 'RU-SVE',
    value: 'Sverdlovsk Oblast',
    localName: 'Свердловская область',
  },
  {
    parent: 'RU',
    key: 'RU-TAM',
    value: 'Tambov Oblast',
    localName: 'Тамбовская область',
  },
  {
    parent: 'RU',
    key: 'RU-TOM',
    value: 'Tomsk Oblast',
    localName: 'Томская область',
  },
  {
    parent: 'RU',
    key: 'RU-TUL',
    value: 'Tula Oblast',
    localName: 'Тульская область',
  },
  {
    parent: 'RU',
    key: 'RU-TVE',
    value: 'Tver Oblast',
    localName: 'Тверская область',
  },
  {
    parent: 'RU',
    key: 'RU-TYU',
    value: 'Tyumen Oblast',
    localName: 'Тюменская область',
  },
  {
    parent: 'RU',
    key: 'RU-ULY',
    value: 'Ulyanovsk Oblast',
    localName: 'Ульяновская область',
  },
  {
    parent: 'RU',
    key: 'RU-VLA',
    value: 'Vladimir Oblast',
    localName: 'Владимирская область',
  },
  {
    parent: 'RU',
    key: 'RU-VGG',
    value: 'Volgograd Oblast',
    localName: 'Волгоградская область',
  },
  {
    parent: 'RU',
    key: 'RU-VLG',
    value: 'Vologda Oblast',
    localName: 'Вологодская область',
  },
  {
    parent: 'RU',
    key: 'RU-VOR',
    value: 'Voronezh Oblast',
    localName: 'Воронежская область',
  },
  {
    parent: 'RU',
    key: 'RU-YAR',
    value: 'Yaroslavl Oblast',
    localName: 'Ярославская область',
  },
  {
    parent: 'RU',
    key: 'RU-CHU',
    value: 'Chukotka Autonomous Okrug',
    localName: 'Чукотский автономный округ',
  },
  {
    parent: 'RU',
    key: 'RU-KHM',
    value: 'Khanty-Mansi Autonomous Okrug',
    localName: 'Ханты-Мансийский автономный округ',
  },
  {
    parent: 'RU',
    key: 'RU-NEN',
    value: 'Nenets Autonomous Okrug',
    localName: 'Ненецкий автономный округ',
  },
  {
    parent: 'RU',
    key: 'RU-YAN',
    value: 'Yamalo-Nenets Autonomous Okrug',
    localName: 'Ямало-Ненецкий автономный округ',
  },
  {
    parent: 'RU',
    key: 'RU-MOW',
    value: 'Moscow',
    localName: 'Москва',
  },
  {
    parent: 'RU',
    key: 'RU-SPE',
    value: 'Saint Petersburg',
    localName: 'Санкт-Петербург',
  },
  {
    parent: 'RU',
    key: 'RU-SEV',
    value: 'Sevastopol',
    localName: 'Севастополь',
  },
  {
    parent: 'NG',
    key: 'NG-AB',
    value: 'Abia',
    localName: 'Abia',
  },
  {
    parent: 'NG',
    key: 'NG-AD',
    value: 'Adamawa',
    localName: 'Adamawa',
  },
  {
    parent: 'NG',
    key: 'NG-AK',
    value: 'Akwa Ibom',
    localName: 'Akwa Ibom',
  },
  {
    parent: 'NG',
    key: 'NG-AN',
    value: 'Anambra',
    localName: 'Anambra',
  },
  {
    parent: 'NG',
    key: 'NG-BA',
    value: 'Bauchi',
    localName: 'Bauchi',
  },
  {
    parent: 'NG',
    key: 'NG-BY',
    value: 'Bayelsa',
    localName: 'Bayelsa',
  },
  {
    parent: 'NG',
    key: 'NG-BE',
    value: 'Benue',
    localName: 'Benue',
  },
  {
    parent: 'NG',
    key: 'NG-BO',
    value: 'Borno',
    localName: 'Borno',
  },
  {
    parent: 'NG',
    key: 'NG-CR',
    value: 'Cross River',
    localName: 'Cross River',
  },
  {
    parent: 'NG',
    key: 'NG-DE',
    value: 'Delta',
    localName: 'Delta',
  },
  {
    parent: 'NG',
    key: 'NG-EB',
    value: 'Ebonyi',
    localName: 'Ebonyi',
  },
  {
    parent: 'NG',
    key: 'NG-ED',
    value: 'Edo',
    localName: 'Edo',
  },
  {
    parent: 'NG',
    key: 'NG-EK',
    value: 'Ekiti',
    localName: 'Ekiti',
  },
  {
    parent: 'NG',
    key: 'NG-EN',
    value: 'Enugu',
    localName: 'Enugu',
  },
  {
    parent: 'NG',
    key: 'NG-GO',
    value: 'Gombe',
    localName: 'Gombe',
  },
  {
    parent: 'NG',
    key: 'NG-IM',
    value: 'Imo',
    localName: 'Imo',
  },
  {
    parent: 'NG',
    key: 'NG-JI',
    value: 'Jigawa',
    localName: 'Jigawa',
  },
  {
    parent: 'NG',
    key: 'NG-KD',
    value: 'Kaduna',
    localName: 'Kaduna',
  },
  {
    parent: 'NG',
    key: 'NG-KN',
    value: 'Kano',
    localName: 'Kano',
  },
  {
    parent: 'NG',
    key: 'NG-KT',
    value: 'Katsina',
    localName: 'Katsina',
  },
  {
    parent: 'NG',
    key: 'NG-KE',
    value: 'Kebbi',
    localName: 'Kebbi',
  },
  {
    parent: 'NG',
    key: 'NG-KO',
    value: 'Kogi',
    localName: 'Kogi',
  },
  {
    parent: 'NG',
    key: 'NG-KW',
    value: 'Kwara',
    localName: 'Kwara',
  },
  {
    parent: 'NG',
    key: 'NG-LA',
    value: 'Lagos',
    localName: 'Lagos',
  },
  {
    parent: 'NG',
    key: 'NG-NA',
    value: 'Nasarawa',
    localName: 'Nasarawa',
  },
  {
    parent: 'NG',
    key: 'NG-NI',
    value: 'Niger',
    localName: 'Niger',
  },
  {
    parent: 'NG',
    key: 'NG-OG',
    value: 'Ogun',
    localName: 'Ogun',
  },
  {
    parent: 'NG',
    key: 'NG-ON',
    value: 'Ondo',
    localName: 'Ondo',
  },
  {
    parent: 'NG',
    key: 'NG-OS',
    value: 'Osun',
    localName: 'Osun',
  },
  {
    parent: 'NG',
    key: 'NG-OY',
    value: 'Oyo',
    localName: 'Oyo',
  },
  {
    parent: 'NG',
    key: 'NG-PL',
    value: 'Plateau',
    localName: 'Plateau',
  },
  {
    parent: 'NG',
    key: 'NG-RI',
    value: 'Rivers',
    localName: 'Rivers',
  },
  {
    parent: 'NG',
    key: 'NG-SO',
    value: 'Sokoto',
    localName: 'Sokoto',
  },
  {
    parent: 'NG',
    key: 'NG-TA',
    value: 'Taraba',
    localName: 'Taraba',
  },
  {
    parent: 'NG',
    key: 'NG-YO',
    value: 'Yobe',
    localName: 'Yobe',
  },
  {
    parent: 'NG',
    key: 'NG-ZA',
    value: 'Zamfara',
    localName: 'Zamfara',
  },
  {
    parent: 'NG',
    key: 'NG-FC',
    value: 'Federal Capital Territory',
    localName: 'Federal Capital Territory',
  },
  {
    parent: 'KE',
    key: 'KE-1',
    value: 'Baringo',
    localName: 'Baringo',
  },
  {
    parent: 'KE',
    key: 'KE-2',
    value: 'Bomet',
    localName: 'Bomet',
  },
  {
    parent: 'KE',
    key: 'KE-3',
    value: 'Bungoma',
    localName: 'Bungoma',
  },
  {
    parent: 'KE',
    key: 'KE-4',
    value: 'Busia',
    localName: 'Busia',
  },
  {
    parent: 'KE',
    key: 'KE-5',
    value: 'Elgeyo Marakwet',
    localName: 'Elgeyo Marakwet',
  },
  {
    parent: 'KE',
    key: 'KE-6',
    value: 'Embu',
    localName: 'Embu',
  },
  {
    parent: 'KE',
    key: 'KE-7',
    value: 'Garissa',
    localName: 'Garissa',
  },
  {
    parent: 'KE',
    key: 'KE-8',
    value: 'Homa Bay',
    localName: 'Homa Bay',
  },
  {
    parent: 'KE',
    key: 'KE-9',
    value: 'Isiolo',
    localName: 'Isiolo',
  },
  {
    parent: 'KE',
    key: 'KE-10',
    value: 'Kajiado',
    localName: 'Kajiado',
  },
  {
    parent: 'KE',
    key: 'KE-11',
    value: 'Kakamega',
    localName: 'Kakamega',
  },
  {
    parent: 'KE',
    key: 'KE-12',
    value: 'Kericho',
    localName: 'Kericho',
  },
  {
    parent: 'KE',
    key: 'KE-13',
    value: 'Kiambu',
    localName: 'Kiambu',
  },
  {
    parent: 'KE',
    key: 'KE-14',
    value: 'Kilifi',
    localName: 'Kilifi',
  },
  {
    parent: 'KE',
    key: 'KE-15',
    value: 'Kirinyaga',
    localName: 'Kirinyaga',
  },
  {
    parent: 'KE',
    key: 'KE-16',
    value: 'Kisii',
    localName: 'Kisii',
  },
  {
    parent: 'KE',
    key: 'KE-17',
    value: 'Kisumu',
    localName: 'Kisumu',
  },
  {
    parent: 'KE',
    key: 'KE-18',
    value: 'Kitui',
    localName: 'Kitui',
  },
  {
    parent: 'KE',
    key: 'KE-19',
    value: 'Kwale',
    localName: 'Kwale',
  },
  {
    parent: 'KE',
    key: 'KE-20',
    value: 'Laikipia',
    localName: 'Laikipia',
  },
  {
    parent: 'KE',
    key: 'KE-21',
    value: 'Lamu',
    localName: 'Lamu',
  },
  {
    parent: 'KE',
    key: 'KE-22',
    value: 'Machakos',
    localName: 'Machakos',
  },
  {
    parent: 'KE',
    key: 'KE-23',
    value: 'Makueni',
    localName: 'Makueni',
  },
  {
    parent: 'KE',
    key: 'KE-24',
    value: 'Mandera',
    localName: 'Mandera',
  },
  {
    parent: 'KE',
    key: 'KE-25',
    value: 'Marsabit',
    localName: 'Marsabit',
  },
  {
    parent: 'KE',
    key: 'KE-26',
    value: 'Meru',
    localName: 'Meru',
  },
  {
    parent: 'KE',
    key: 'KE-27',
    value: 'Migori',
    localName: 'Migori',
  },
  {
    parent: 'KE',
    key: 'KE-28',
    value: 'Mombasa',
    localName: 'Mombasa',
  },
  {
    parent: 'KE',
    key: 'KE-29',
    value: "Murang'a",
    localName: "Murang'a",
  },
  {
    parent: 'KE',
    key: 'KE-30',
    value: 'Nairobi City',
    localName: 'Nairobi City',
  },
  {
    parent: 'KE',
    key: 'KE-31',
    value: 'Nakuru',
    localName: 'Nakuru',
  },
  {
    parent: 'KE',
    key: 'KE-32',
    value: 'Nandi',
    localName: 'Nandi',
  },
  {
    parent: 'KE',
    key: 'KE-33',
    value: 'Narok',
    localName: 'Narok',
  },
  {
    parent: 'KE',
    key: 'KE-34',
    value: 'Nyamira',
    localName: 'Nyamira',
  },
  {
    parent: 'KE',
    key: 'KE-35',
    value: 'Nyandarua',
    localName: 'Nyandarua',
  },
  {
    parent: 'KE',
    key: 'KE-36',
    value: 'Nyeri',
    localName: 'Nyeri',
  },
  {
    parent: 'KE',
    key: 'KE-37',
    value: 'Samburu',
    localName: 'Samburu',
  },
  {
    parent: 'KE',
    key: 'KE-38',
    value: 'Siaya',
    localName: 'Siaya',
  },
  {
    parent: 'KE',
    key: 'KE-39',
    value: 'Taita Taveta',
    localName: 'Taita Taveta',
  },
  {
    parent: 'KE',
    key: 'KE-40',
    value: 'Tana River',
    localName: 'Tana River',
  },
  {
    parent: 'KE',
    key: 'KE-41',
    value: 'Tharaka Nithi',
    localName: 'Tharaka Nithi',
  },
  {
    parent: 'KE',
    key: 'KE-42',
    value: 'Trans Nzoia',
    localName: 'Trans Nzoia',
  },
  {
    parent: 'KE',
    key: 'KE-43',
    value: 'Turkana',
    localName: 'Turkana',
  },
  {
    parent: 'KE',
    key: 'KE-44',
    value: 'Uasin Gishu',
    localName: 'Uasin Gishu',
  },
  {
    parent: 'KE',
    key: 'KE-45',
    value: 'Vihiga',
    localName: 'Vihiga',
  },
  {
    parent: 'KE',
    key: 'KE-46',
    value: 'Wajir',
    localName: 'Wajir',
  },
  {
    parent: 'KE',
    key: 'KE-47',
    value: 'West Pokot',
    localName: 'West Pokot',
  },
  {
    parent: 'IN',
    key: 'IN-AN',
    value: 'Andaman and Nicobar Islands',
    localName: 'Andaman and Nicobar Islands',
  },
  {
    parent: 'IN',
    key: 'IN-AP',
    value: 'Andhra Pradesh',
    localName: 'Andhra Pradesh',
  },
  {
    parent: 'IN',
    key: 'IN-AR',
    value: 'Arunachal Pradesh',
    localName: 'Arunachal Pradesh',
  },
  {
    parent: 'IN',
    key: 'IN-AS',
    value: 'Assam',
    localName: 'Assam',
  },
  {
    parent: 'IN',
    key: 'IN-BR',
    value: 'Bihar',
    localName: 'Bihar',
  },
  {
    parent: 'IN',
    key: 'IN-CH',
    value: 'Chandigarh',
    localName: 'Chandigarh',
  },
  {
    parent: 'IN',
    key: 'IN-CT',
    value: 'Chhattisgarh',
    localName: 'Chhattisgarh',
  },
  {
    parent: 'IN',
    key: 'IN-DN',
    value: 'Dadra and Nagar Haveli and Daman and Diu',
    localName: 'Dadra and Nagar Haveli and Daman and Diu',
  },
  {
    parent: 'IN',
    key: 'IN-DL',
    value: 'Delhi',
    localName: 'Delhi',
  },
  {
    parent: 'IN',
    key: 'IN-GA',
    value: 'Goa',
    localName: 'Goa',
  },
  {
    parent: 'IN',
    key: 'IN-GJ',
    value: 'Gujarat',
    localName: 'Gujarat',
  },
  {
    parent: 'IN',
    key: 'IN-HR',
    value: 'Haryana',
    localName: 'Haryana',
  },
  {
    parent: 'IN',
    key: 'IN-HP',
    value: 'Himachal Pradesh',
    localName: 'Himachal Pradesh',
  },
  {
    parent: 'IN',
    key: 'IN-JK',
    value: 'Jammu and Kashmir',
    localName: 'Jammu and Kashmir',
  },
  {
    parent: 'IN',
    key: 'IN-JH',
    value: 'Jharkhand',
    localName: 'Jharkhand',
  },
  {
    parent: 'IN',
    key: 'IN-KA',
    value: 'Karnataka',
    localName: 'Karnataka',
  },
  {
    parent: 'IN',
    key: 'IN-KL',
    value: 'Kerala',
    localName: 'Kerala',
  },
  {
    parent: 'IN',
    key: 'IN-LA',
    value: 'Ladakh',
    localName: 'Ladakh',
  },
  {
    parent: 'IN',
    key: 'IN-LD',
    value: 'Lakshadweep',
    localName: 'Lakshadweep',
  },
  {
    parent: 'IN',
    key: 'IN-MP',
    value: 'Madhya Pradesh',
    localName: 'Madhya Pradesh',
  },
  {
    parent: 'IN',
    key: 'IN-MH',
    value: 'Maharashtra',
    localName: 'Maharashtra',
  },
  {
    parent: 'IN',
    key: 'IN-MN',
    value: 'Manipur',
    localName: 'Manipur',
  },
  {
    parent: 'IN',
    key: 'IN-ML',
    value: 'Meghalaya',
    localName: 'Meghalaya',
  },
  {
    parent: 'IN',
    key: 'IN-MZ',
    value: 'Mizoram',
    localName: 'Mizoram',
  },
  {
    parent: 'IN',
    key: 'IN-NL',
    value: 'Nagaland',
    localName: 'Nagaland',
  },
  {
    parent: 'IN',
    key: 'IN-OR',
    value: 'Odisha',
    localName: 'Odisha',
  },
  {
    parent: 'IN',
    key: 'IN-PY',
    value: 'Puducherry',
    localName: 'Puducherry',
  },
  {
    parent: 'IN',
    key: 'IN-PB',
    value: 'Punjab',
    localName: 'Punjab',
  },
  {
    parent: 'IN',
    key: 'IN-RJ',
    value: 'Rajasthan',
    localName: 'Rajasthan',
  },
  {
    parent: 'IN',
    key: 'IN-SK',
    value: 'Sikkim',
    localName: 'Sikkim',
  },
  {
    parent: 'IN',
    key: 'IN-TN',
    value: 'Tamil Nadu',
    localName: 'Tamil Nadu',
  },
  {
    parent: 'IN',
    key: 'IN-TG',
    value: 'Telangana',
    localName: 'Telangana',
  },
  {
    parent: 'IN',
    key: 'IN-TR',
    value: 'Tripura',
    localName: 'Tripura',
  },
  {
    parent: 'IN',
    key: 'IN-UP',
    value: 'Uttar Pradesh',
    localName: 'Uttar Pradesh',
  },
  {
    parent: 'IN',
    key: 'IN-UT',
    value: 'Uttarakhand',
    localName: 'Uttarakhand',
  },
  {
    parent: 'IN',
    key: 'IN-WB',
    value: 'West Bengal',
    localName: 'West Bengal',
  },
  {
    parent: 'JP',
    key: 'JP-1',
    value: 'Hokkaidō',
    localName: '北海道',
  },
  {
    parent: 'JP',
    key: 'JP-2',
    value: 'Aomori',
    localName: '青森県',
  },
  {
    parent: 'JP',
    key: 'JP-3',
    value: 'Iwate',
    localName: '岩手県',
  },
  {
    parent: 'JP',
    key: 'JP-4',
    value: 'Miyagi',
    localName: '宮城県',
  },
  {
    parent: 'JP',
    key: 'JP-5',
    value: 'Akita',
    localName: '秋田県',
  },
  {
    parent: 'JP',
    key: 'JP-6',
    value: 'Yamagata',
    localName: '山形県',
  },
  {
    parent: 'JP',
    key: 'JP-7',
    value: 'Fukushima',
    localName: '福島県',
  },
  {
    parent: 'JP',
    key: 'JP-8',
    value: 'Ibaraki',
    localName: '茨城県',
  },
  {
    parent: 'JP',
    key: 'JP-9',
    value: 'Tochigi',
    localName: '栃木県',
  },
  {
    parent: 'JP',
    key: 'JP-10',
    value: 'Gunma',
    localName: '群馬県',
  },
  {
    parent: 'JP',
    key: 'JP-11',
    value: 'Saitama',
    localName: '埼玉県',
  },
  {
    parent: 'JP',
    key: 'JP-12',
    value: 'Chiba',
    localName: '千葉県',
  },
  {
    parent: 'JP',
    key: 'JP-13',
    value: 'Tokyo',
    localName: '東京',
  },
  {
    parent: 'JP',
    key: 'JP-14',
    value: 'Kanagawa',
    localName: '神奈川県',
  },
  {
    parent: 'JP',
    key: 'JP-15',
    value: 'Niigata',
    localName: '新潟県',
  },
  {
    parent: 'JP',
    key: 'JP-16',
    value: 'Toyama',
    localName: '富山県',
  },
  {
    parent: 'JP',
    key: 'JP-17',
    value: 'Ishikawa',
    localName: '石川県',
  },
  {
    parent: 'JP',
    key: 'JP-18',
    value: 'Fukui',
    localName: '福井県',
  },
  {
    parent: 'JP',
    key: 'JP-19',
    value: 'Yamanashi',
    localName: '山梨県',
  },
  {
    parent: 'JP',
    key: 'JP-20',
    value: 'Nagano',
    localName: '長野県',
  },
  {
    parent: 'JP',
    key: 'JP-21',
    value: 'Gifu',
    localName: '岐阜県',
  },
  {
    parent: 'JP',
    key: 'JP-22',
    value: 'Shizuoka',
    localName: '静岡県',
  },
  {
    parent: 'JP',
    key: 'JP-23',
    value: 'Aichi',
    localName: '愛知県',
  },
  {
    parent: 'JP',
    key: 'JP-24',
    value: 'Mie',
    localName: '三重県',
  },
  {
    parent: 'JP',
    key: 'JP-25',
    value: 'Shiga',
    localName: '滋賀県',
  },
  {
    parent: 'JP',
    key: 'JP-26',
    value: 'Kyōto',
    localName: '京都府',
  },
  {
    parent: 'JP',
    key: 'JP-27',
    value: 'Ōsaka',
    localName: '大阪府',
  },
  {
    parent: 'JP',
    key: 'JP-28',
    value: 'Hyōgo',
    localName: '兵庫県',
  },
  {
    parent: 'JP',
    key: 'JP-29',
    value: 'Nara',
    localName: '奈良県',
  },
  {
    parent: 'JP',
    key: 'JP-30',
    value: 'Wakayama',
    localName: '和歌山県',
  },
  {
    parent: 'JP',
    key: 'JP-31',
    value: 'Tottori',
    localName: '鳥取県',
  },
  {
    parent: 'JP',
    key: 'JP-32',
    value: 'Shimane',
    localName: '島根県',
  },
  {
    parent: 'JP',
    key: 'JP-33',
    value: 'Okayama',
    localName: '岡山県',
  },
  {
    parent: 'JP',
    key: 'JP-34',
    value: 'Hiroshima',
    localName: '広島県',
  },
  {
    parent: 'JP',
    key: 'JP-35',
    value: 'Yamaguchi',
    localName: '山口県',
  },
  {
    parent: 'JP',
    key: 'JP-36',
    value: 'Tokushima',
    localName: '徳島県',
  },
  {
    parent: 'JP',
    key: 'JP-37',
    value: 'Kagawa',
    localName: '香川県',
  },
  {
    parent: 'JP',
    key: 'JP-38',
    value: 'Ehime',
    localName: '愛媛県',
  },
  {
    parent: 'JP',
    key: 'JP-39',
    value: 'Kōchi',
    localName: '高知県',
  },
  {
    parent: 'JP',
    key: 'JP-40',
    value: 'Fukuoka',
    localName: '福岡県',
  },
  {
    parent: 'JP',
    key: 'JP-41',
    value: 'Saga',
    localName: '佐賀県',
  },
  {
    parent: 'JP',
    key: 'JP-42',
    value: 'Nagasaki',
    localName: '長崎県',
  },
  {
    parent: 'JP',
    key: 'JP-43',
    value: 'Kumamoto',
    localName: '熊本県',
  },
  {
    parent: 'JP',
    key: 'JP-44',
    value: 'Ōita',
    localName: '大分県',
  },
  {
    parent: 'JP',
    key: 'JP-45',
    value: 'Miyazaki',
    localName: '宮崎県',
  },
  {
    parent: 'JP',
    key: 'JP-46',
    value: 'Kagoshima',
    localName: '鹿児島県',
  },
  {
    parent: 'JP',
    key: 'JP-47',
    value: 'Okinawa',
    localName: '沖縄県',
  },
  {
    parent: 'PK',
    key: 'PK-JK',
    value: 'Azad Jammu and Kashmir',
    localName: 'Azad Jammu and Kashmir',
  },
  {
    parent: 'PK',
    key: 'PK-BA',
    value: 'Balochistan',
    localName: 'Balochistan',
  },
  {
    parent: 'PK',
    key: 'PK-GB',
    value: 'Gilgit-Baltistan',
    localName: 'Gilgit-Baltistan',
  },
  {
    parent: 'PK',
    key: 'PK-IS',
    value: 'Islamabad Capital Territory',
    localName: 'Islamabad Capital Territory',
  },
  {
    parent: 'PK',
    key: 'PK-KP',
    value: 'Khyber Pakhtunkhwa',
    localName: 'Khyber Pakhtunkhwa',
  },
  {
    parent: 'PK',
    key: 'PK-PB',
    value: 'Punjab',
    localName: 'Punjab',
  },
  {
    parent: 'PK',
    key: 'PK-SD',
    value: 'Sindh',
    localName: 'Sindh',
  },
  {
    parent: 'PK',
    key: 'PK-TT',
    value: 'Tribal Areas',
    localName: 'Tribal Areas',
  },
  {
    parent: 'MY',
    key: 'MY-JH',
    value: 'Johor',
    localName: 'Johor',
  },
  {
    parent: 'MY',
    key: 'MY-KD',
    value: 'Kedah',
    localName: 'Kedah',
  },
  {
    parent: 'MY',
    key: 'MY-KL',
    value: 'Kuala Lumpur',
    localName: 'Kuala Lumpur',
  },
  {
    parent: 'MY',
    key: 'MY-LB',
    value: 'Labuan',
    localName: 'Labuan',
  },
  {
    parent: 'MY',
    key: 'MY-ML',
    value: 'Malacca',
    localName: 'Malacca',
  },
  {
    parent: 'MY',
    key: 'MY-NS',
    value: 'Negeri Sembilan',
    localName: 'Negeri Sembilan',
  },
  {
    parent: 'MY',
    key: 'MY-PH',
    value: 'Pahang',
    localName: 'Pahang',
  },
  {
    parent: 'MY',
    key: 'MY-PG',
    value: 'Penang',
    localName: 'Penang',
  },
  {
    parent: 'MY',
    key: 'MY-PK',
    value: 'Perak',
    localName: 'Perak',
  },
  {
    parent: 'MY',
    key: 'MY-PS',
    value: 'Perlis',
    localName: 'Perlis',
  },
  {
    parent: 'MY',
    key: 'MY-PT',
    value: 'Putrajaya',
    localName: 'Putrajaya',
  },
  {
    parent: 'MY',
    key: 'MY-SB',
    value: 'Sabah',
    localName: 'Sabah',
  },
  {
    parent: 'MY',
    key: 'MY-SR',
    value: 'Sarawak',
    localName: 'Sarawak',
  },
  {
    parent: 'MY',
    key: 'MY-SL',
    value: 'Selangor',
    localName: 'Selangor',
  },
  {
    parent: 'MY',
    key: 'MY-TR',
    value: 'Terengganu',
    localName: 'Terengganu',
  },
  {
    parent: 'AU',
    key: 'AU-ACT',
    value: 'Australian Capital Territory',
    localName: 'Australian Capital Territory',
  },
  {
    parent: 'AU',
    key: 'AU-NSW',
    value: 'New South Wales',
    localName: 'New South Wales',
  },
  {
    parent: 'AU',
    key: 'AU-NT',
    value: 'Northern Territory',
    localName: 'Northern Territory',
  },
  {
    parent: 'AU',
    key: 'AU-QLD',
    value: 'Queensland',
    localName: 'Queensland',
  },
  {
    parent: 'AU',
    key: 'AU-SA',
    value: 'South Australia',
    localName: 'South Australia',
  },
  {
    parent: 'AU',
    key: 'AU-TAS',
    value: 'Tasmania',
    localName: 'Tasmania',
  },
  {
    parent: 'AU',
    key: 'AU-VIC',
    value: 'Victoria',
    localName: 'Victoria',
  },
  {
    parent: 'AU',
    key: 'AU-WA',
    value: 'Western Australia',
    localName: 'Western Australia',
  },
  {
    parent: 'NZ',
    key: 'NZ-AUK',
    value: 'Auckland',
    localName: 'Auckland',
  },
  {
    parent: 'NZ',
    key: 'NZ-BOP',
    value: 'Bay of Plenty',
    localName: 'Bay of Plenty',
  },
  {
    parent: 'NZ',
    key: 'NZ-CAN',
    value: 'Canterbury',
    localName: 'Canterbury',
  },
  {
    parent: 'NZ',
    key: 'NZ-GIS',
    value: 'Gisborne',
    localName: 'Gisborne',
  },
  {
    parent: 'NZ',
    key: 'NZ-HKB',
    value: "Hawke's Bay",
    localName: "Hawke's Bay",
  },
  {
    parent: 'NZ',
    key: 'NZ-MWT',
    value: 'Manawatu-Wanganui',
    localName: 'Manawatu-Wanganui',
  },
  {
    parent: 'NZ',
    key: 'NZ-MBH',
    value: 'Marlborough',
    localName: 'Marlborough',
  },
  {
    parent: 'NZ',
    key: 'NZ-NSN',
    value: 'Nelson',
    localName: 'Nelson',
  },
  {
    parent: 'NZ',
    key: 'NZ-NTL',
    value: 'Northland',
    localName: 'Northland',
  },
  {
    parent: 'NZ',
    key: 'NZ-OTA',
    value: 'Otago',
    localName: 'Otago',
  },
  {
    parent: 'NZ',
    key: 'NZ-STL',
    value: 'Southland',
    localName: 'Southland',
  },
  {
    parent: 'NZ',
    key: 'NZ-TKI',
    value: 'Taranaki',
    localName: 'Taranaki',
  },
  {
    parent: 'NZ',
    key: 'NZ-TAS',
    value: 'Tasman',
    localName: 'Tasman',
  },
  {
    parent: 'NZ',
    key: 'NZ-WKO',
    value: 'Waikato',
    localName: 'Waikato',
  },
  {
    parent: 'NZ',
    key: 'NZ-WGN',
    value: 'Wellington',
    localName: 'Wellington',
  },
  {
    parent: 'NZ',
    key: 'NZ-WTC',
    value: 'West Coast',
    localName: 'West Coast',
  },
  {
    parent: 'ID',
    key: 'ID-AC',
    value: 'Aceh',
    localName: 'Aceh',
  },
  {
    parent: 'ID',
    key: 'ID-BA',
    value: 'Bali',
    localName: 'Bali',
  },
  {
    parent: 'ID',
    key: 'ID-BB',
    value: 'Bangka Belitung',
    localName: 'Bangka Belitung',
  },
  {
    parent: 'ID',
    key: 'ID-BT',
    value: 'Banten',
    localName: 'Banten',
  },
  {
    parent: 'ID',
    key: 'ID-BE',
    value: 'Bengkulu',
    localName: 'Bengkulu',
  },
  {
    parent: 'ID',
    key: 'ID-GO',
    value: 'Gorontalo',
    localName: 'Gorontalo',
  },
  {
    parent: 'ID',
    key: 'ID-JK',
    value: 'Jakarta',
    localName: 'Jakarta',
  },
  {
    parent: 'ID',
    key: 'ID-JA',
    value: 'Jambi',
    localName: 'Jambi',
  },
  {
    parent: 'ID',
    key: 'ID-JB',
    value: 'West Java',
    localName: 'West Java',
  },
  {
    parent: 'ID',
    key: 'ID-JT',
    value: 'Central Java',
    localName: 'Central Java',
  },
  {
    parent: 'ID',
    key: 'ID-JI',
    value: 'East Java',
    localName: 'East Java',
  },
  {
    parent: 'ID',
    key: 'ID-KB',
    value: 'West Kalimantan',
    localName: 'West Kalimantan',
  },
  {
    parent: 'ID',
    key: 'ID-KT',
    value: 'Central Kalimantan',
    localName: 'Central Kalimantan',
  },
  {
    parent: 'ID',
    key: 'ID-KI',
    value: 'East Kalimantan',
    localName: 'East Kalimantan',
  },
  {
    parent: 'ID',
    key: 'ID-KS',
    value: 'South Kalimantan',
    localName: 'South Kalimantan',
  },
  {
    parent: 'ID',
    key: 'ID-KU',
    value: 'North Kalimantan',
    localName: 'North Kalimantan',
  },
  {
    parent: 'ID',
    key: 'ID-NT',
    value: 'West Nusa Tenggara',
    localName: 'West Nusa Tenggara',
  },
  {
    parent: 'ID',
    key: 'ID-NU',
    value: 'East Nusa Tenggara',
    localName: 'East Nusa Tenggara',
  },
  {
    parent: 'ID',
    key: 'ID-PA',
    value: 'Papua',
    localName: 'Papua',
  },
  {
    parent: 'ID',
    key: 'ID-PB',
    value: 'West Papua',
    localName: 'West Papua',
  },
  {
    parent: 'ID',
    key: 'ID-RI',
    value: 'Riau',
    localName: 'Riau',
  },
  {
    parent: 'ID',
    key: 'ID-SR',
    value: 'West Sulawesi',
    localName: 'West Sulawesi',
  },
  {
    parent: 'ID',
    key: 'ID-SN',
    value: 'South Sulawesi',
    localName: 'South Sulawesi',
  },
  {
    parent: 'ID',
    key: 'ID-ST',
    value: 'Central Sulawesi',
    localName: 'Central Sulawesi',
  },
  {
    parent: 'ID',
    key: 'ID-SG',
    value: 'Southeast Sulawesi',
    localName: 'Southeast Sulawesi',
  },
  {
    parent: 'ID',
    key: 'ID-SA',
    value: 'North Sulawesi',
    localName: 'North Sulawesi',
  },
  {
    parent: 'ID',
    key: 'ID-SB',
    value: 'West Sumatra',
    localName: 'West Sumatra',
  },
  {
    parent: 'ID',
    key: 'ID-SS',
    value: 'South Sumatra',
    localName: 'South Sumatra',
  },
  {
    parent: 'ID',
    key: 'ID-SU',
    value: 'North Sumatra',
    localName: 'North Sumatra',
  },
  {
    parent: 'ID',
    key: 'ID-YO',
    value: 'Yogyakarta',
    localName: 'Yogyakarta',
  },
  {
    parent: 'CN',
    key: 'CN-BJ',
    value: 'Beijing',
    localName: '北京',
  },
  {
    parent: 'CN',
    key: 'CN-TJ',
    value: 'Tianjin',
    localName: '天津',
  },
  {
    parent: 'CN',
    key: 'CN-HE',
    value: 'Hebei',
    localName: '河北',
  },
  {
    parent: 'CN',
    key: 'CN-SX',
    value: 'Shanxi',
    localName: '山西',
  },
  {
    parent: 'CN',
    key: 'CN-NM',
    value: 'Inner Mongolia',
    localName: '内蒙古',
  },
  {
    parent: 'CN',
    key: 'CN-LN',
    value: 'Liaoning',
    localName: '辽宁',
  },
  {
    parent: 'CN',
    key: 'CN-JL',
    value: 'Jilin',
    localName: '吉林',
  },
  {
    parent: 'CN',
    key: 'CN-HL',
    value: 'Heilongjiang',
    localName: '黑龙江',
  },
  {
    parent: 'CN',
    key: 'CN-SH',
    value: 'Shanghai',
    localName: '上海',
  },
  {
    parent: 'CN',
    key: 'CN-JS',
    value: 'Jiangsu',
    localName: '江苏',
  },
  {
    parent: 'CN',
    key: 'CN-ZJ',
    value: 'Zhejiang',
    localName: '浙江',
  },
  {
    parent: 'CN',
    key: 'CN-AH',
    value: 'Anhui',
    localName: '安徽',
  },
  {
    parent: 'CN',
    key: 'CN-FJ',
    value: 'Fujian',
    localName: '福建',
  },
  {
    parent: 'CN',
    key: 'CN-JX',
    value: 'Jiangxi',
    localName: '江西',
  },
  {
    parent: 'CN',
    key: 'CN-SD',
    value: 'Shandong',
    localName: '山东',
  },
  {
    parent: 'CN',
    key: 'CN-HA',
    value: 'Henan',
    localName: '河南',
  },
  {
    parent: 'CN',
    key: 'CN-HB',
    value: 'Hubei',
    localName: '湖北',
  },
  {
    parent: 'CN',
    key: 'CN-HN',
    value: 'Hunan',
    localName: '湖南',
  },
  {
    parent: 'CN',
    key: 'CN-GD',
    value: 'Guangdong',
    localName: '广东',
  },
  {
    parent: 'CN',
    key: 'CN-GX',
    value: 'Guangxi',
    localName: '广西',
  },
  {
    parent: 'CN',
    key: 'CN-HI',
    value: 'Hainan',
    localName: '海南',
  },
  {
    parent: 'CN',
    key: 'CN-CQ',
    value: 'Chongqing',
    localName: '重庆',
  },
  {
    parent: 'CN',
    key: 'CN-SC',
    value: 'Sichuan',
    localName: '四川',
  },
  {
    parent: 'CN',
    key: 'CN-GZ',
    value: 'Guizhou',
    localName: '贵州',
  },
  {
    parent: 'CN',
    key: 'CN-YN',
    value: 'Yunnan',
    localName: '云南',
  },
  {
    parent: 'CN',
    key: 'CN-XZ',
    value: 'Tibet',
    localName: '西藏',
  },
  {
    parent: 'CN',
    key: 'CN-SN',
    value: 'Shaanxi',
    localName: '陕西',
  },
  {
    parent: 'CN',
    key: 'CN-GS',
    value: 'Gansu',
    localName: '甘肃',
  },
  {
    parent: 'CN',
    key: 'CN-QH',
    value: 'Qinghai',
    localName: '青海',
  },
  {
    parent: 'CN',
    key: 'CN-NX',
    value: 'Ningxia',
    localName: '宁夏',
  },
  {
    parent: 'CN',
    key: 'CN-XJ',
    value: 'Xinjiang',
    localName: '新疆',
  },
  {
    parent: 'CN',
    key: 'CN-TW',
    value: 'Taiwan',
    localName: '台湾',
  },
  {
    parent: 'CN',
    key: 'CN-HK',
    value: 'Hong Kong',
    localName: '香港',
  },
  {
    parent: 'CN',
    key: 'CN-MO',
    value: 'Macau',
    localName: '澳门',
  },
]
